import Consent from "../components/Welcome/Others/Consent";

const HomePage = () => {
    return (
        <Consent />
    );
};


export default HomePage;